import { r as e } from "../../../../_virtual/index5.js";
import { __require as o } from "./cjs/react-is.production.min.js";
import { __require as i } from "./cjs/react-is.development.js";
(function(r) {
  process.env.NODE_ENV === "production" ? r.exports = o() : r.exports = i();
})(e);
//# sourceMappingURL=index.js.map
